export default __webpack_public_path__ + "static/media/problem1.8a5af684.png";